<template>
  <code class="bg-gray-50 text-gray-900 overflow-hidden rounded-md p-[3px] text-sm font-normal">
      <slot />
    </code>
</template>

<style lang="postcss" scoped>
code.colored {
  background-color: var(--color-gray-900);
}

tbody code {
  font-size: var(--text-sm);
}

a {
  overflow: hidden;
}

a code {
  color: var(--color-primary-500);
  border: 1px dashed transparent;
  font-weight: var(--font-weight-medium);
}

a:hover code {
  border-color: var(--color-primary-500);
}

h1 a code,
h2 a code,
h3 a code,
h4 a code {
  color: var(--color-gray-900);
  position: relative;
  padding-left: calc(var(--spacing) * 2);
  padding-right: calc(var(--spacing) * 2);
  padding-top: calc(var(--spacing) * 1.5);
  padding-bottom: calc(var(--spacing) * 1.5);
  font-weight: var(--font-weight-bold);
  font-size: inherit !important;
}
</style>
